export default __webpack_public_path__ + "static/money-fa659963065113bad547eac28083dc5d.png";